import { render, staticRenderFns } from "./UpdateSimCardInventoriesInfo.vue?vue&type=template&id=c850d438&"
import script from "./UpdateSimCardInventoriesInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateSimCardInventoriesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports